// src/pages/AllPurchaseItemsList.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    FaEye,
    FaEdit,
    FaAngleLeft,
    FaAngleRight,
    FaChevronDown // For dropdown icon
} from 'react-icons/fa';

export default function AllPurchaseItemsList() {
    const navigate = useNavigate();

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480);
    const [containerDynamicHeight, setContainerDynamicHeight] = useState('auto');
    const [selectedMonth, setSelectedMonth] = useState('This Month');

    // Sample data for purchase items
    const [purchaseItems, setPurchaseItems] = useState([
        { id: '13445', orderBy: 'Haider zakir', itemDesc: 'Men, Women, Unisex', total: 25000, purchaseStatus: 'Item Received', paymentMethod: 'Master Card', date: 'April 9, 2025', paymentStatus: 'Complete' },
        { id: '13446', orderBy: 'Ali Khan', itemDesc: 'Women Tops, Casual Wear', total: 18000, purchaseStatus: 'Item Received', paymentMethod: 'Visa Card', date: 'April 8, 2025', paymentStatus: 'Cancel' },
        { id: '13447', orderBy: 'Usman Raza', itemDesc: 'Electronics Gadget, Mobile', total: 35000, purchaseStatus: 'Item Received', paymentMethod: 'JazzCash', date: 'April 7, 2025', paymentStatus: 'Complete' },
        { id: '13448', orderBy: 'Fatima Bibi', itemDesc: 'Kids Toys, Learning Set', total: 12000, purchaseStatus: 'Item Received', paymentMethod: 'Bank Transfer', date: 'April 6, 2025', paymentStatus: 'Cancel' },
        { id: '13449', orderBy: 'Aisha Malik', itemDesc: 'Home Decor, Wall Art', total: 8000, purchaseStatus: 'Item Received', paymentMethod: 'Master Card', date: 'April 5, 2025', paymentStatus: 'Complete' },
        { id: '13450', orderBy: 'Ahmed Sohail', itemDesc: 'Sports Gear, Running Shoes', total: 22000, purchaseStatus: 'Item Received', paymentMethod: 'EasyPaisa', date: 'April 4, 2025', paymentStatus: 'Complete' },
        { id: '13451', orderBy: 'Sana Javed', itemDesc: 'Beauty Products, Skincare', total: 9500, purchaseStatus: 'Item Received', paymentMethod: 'Visa Card', date: 'April 3, 2025', paymentStatus: 'Cancel' },
        { id: '13452', orderBy: 'Imran Abbas', itemDesc: 'Books, Fiction Novel', total: 3000, purchaseStatus: 'Item Received', paymentMethod: 'COD', date: 'April 2, 2025', paymentStatus: 'Complete' },
        { id: '13453', orderBy: 'Zara Noor', itemDesc: 'Kitchen Appliances, Mixer', total: 15000, purchaseStatus: 'Item Received', paymentMethod: 'Master Card', date: 'April 1, 2025', paymentStatus: 'Complete' },
    ]);

    useEffect(() => {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            const currentHeight = window.innerHeight;

            setIsMobile(currentWidth <= 768);
            setIsSmallMobile(currentWidth <= 480);

            const calculatedHeight = currentHeight - (isMobile ? 40 : 80);
            setContainerDynamicHeight(Math.max(calculatedHeight, 600));
        };

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isMobile]);

    const handleViewItem = (id) => {
        console.log('Viewing Purchase Item ID:', id);
    };

    const handleEditItem = (id) => {
        console.log('Edit Purchase Item:', id);
    };

    const styles = {
        mainWrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            width: '100%',
            backgroundColor: 'transparent',
            padding: isSmallMobile ? '0px' : (isMobile ? '15px' : '20px'),
            boxSizing: 'border-box',
            fontFamily: 'Inter, sans-serif',
            overflow: 'hidden', // Added to mainWrapper to prevent outer body scrollbar
        },
        purchaseItemsListPageContainer: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '1200px',
            height: containerDynamicHeight,
            backgroundColor: 'transparent',
            overflowY: 'auto', // Keep auto for scrolling functionality
            padding: isSmallMobile ? '15px' : '20px',
            boxSizing: 'border-box',
            // --- Custom Scrollbar Styles for WebKit (Chrome, Safari, Edge) ---
            WebkitScrollbar: {
                width: '0', // Hide width
                height: '0', // Hide height (for horizontal if it were auto)
            },
            // --- Custom Scrollbar Styles for Firefox ---
            scrollbarWidth: 'none', // Hide scrollbar for Firefox
            // --- Custom Scrollbar Styles for IE/Edge (older) ---
            msOverflowStyle: 'none', // Hide scrollbar for IE/Edge
        },
        headerTitle: {
            fontSize: isSmallMobile ? '20px' : (isMobile ? '24px' : '30px'),
            color: '#000',
            marginBottom: isSmallMobile ? '15px' : '20px',
            fontWeight: 'bold',
            textAlign: 'left',
        },
        purchaseListContainer: {
            backgroundColor: '#000',
            borderRadius: '10px',
            padding: isSmallMobile ? '15px' : '20px',
            color: '#E5D0A5',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
        },
        purchaseListHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '15px',
            flexDirection: isSmallMobile ? 'column' : 'row',
            gap: isSmallMobile ? '10px' : '0',
            textAlign: isSmallMobile ? 'center' : 'left',
        },
        purchaseListTitle: {
            fontSize: isSmallMobile ? '16px' : '20px',
            margin: 0,
            fontWeight: 'bold',
        },
        filterDropdown: {
            backgroundColor: '#E5D0A5',
            color: '#000',
            border: 'none',
            borderRadius: '5px',
            padding: '8px 15px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            transition: 'background-color 0.2s ease',
            whiteSpace: 'nowrap',
        },
        filterDropdownHover: {
            backgroundColor: '#d0b98e',
        },
        tableWrapper: {
            overflowX: 'hidden', // Still hidden for table to prevent its own horizontal scroll
            marginBottom: '15px',
            flexGrow: 1,
            // These are already set to hide internal table scrollbar, keep them
            '::-webkit-scrollbar': {
                display: 'none'
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            tableLayout: 'fixed',
        },
        tableHeader: {
            backgroundColor: '#000',
            color: '#E5D0A5',
            fontSize: '12px',
            textAlign: 'left',
            padding: '8px 0',
            borderBottom: '1px solid #333',
        },
        th: {
            padding: '16px 10px',
            whiteSpace: 'normal',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            boxSizing: 'border-box',
        },
        tableRow: {
            borderBottom: '1px solid #333',
        },
        tableRowHover: {
            backgroundColor: '#1a1a1a',
        },
        td: {
            padding: '16px 10px',
            verticalAlign: 'middle',
            whiteSpace: 'normal',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '12px',
            boxSizing: 'border-box',
        },
        profileIcon: {
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            backgroundColor: '#E5D0A5',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
            marginRight: '5px',
            flexShrink: 0,
        },
        orderByContainer: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
        },
        statusPill: {
            display: 'inline-block',
            padding: '4px 8px',
            borderRadius: '5px',
            fontSize: '10px',
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#000',
            whiteSpace: 'nowrap',
        },
        statusPillComplete: {
            backgroundColor: '#38A169',
            color: '#FFF',
        },
        statusPillCancel: {
            backgroundColor: '#FFC107',
            color: '#000',
        },
        actionButtons: {
            display: 'flex',
            gap: '4px',
            justifyContent: 'center',
            whiteSpace: 'nowrap',
        },
        actionButton: {
            backgroundColor: '#E5D0A5',
            border: 'none',
            borderRadius: '5px',
            padding: '5px 7px',
            cursor: 'pointer',
            fontSize: '12px',
            color: '#000',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s ease',
        },
        actionButtonHover: {
            backgroundColor: '#d0b98e',
        },
        actionButtonIcon: {
            fontSize: '13px',
        },
        paginationContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '15px',
            flexDirection: isSmallMobile ? 'column' : 'row',
            gap: isSmallMobile ? '10px' : '0',
            padding: '0 5px',
        },
        paginationControls: {
            display: 'flex',
            gap: '4px',
            flexWrap: 'wrap',
            justifyContent: isSmallMobile ? 'center' : 'flex-start',
        },
        paginationButton: {
            backgroundColor: '#E5D0A5',
            color: '#000',
            border: '1px solid #000',
            borderRadius: '5px',
            padding: '4px 8px',
            cursor: 'pointer',
            fontSize: '12px',
            transition: 'background-color 0.2s ease',
            minWidth: '25px',
            textAlign: 'center',
        },
        paginationButtonActive: {
            backgroundColor: '#000',
            color: '#E5D0A5',
        },
        paginationButtonHover: {
            backgroundColor: '#d0b98e',
        },
        paginationText: {
            color: '#E5D0A5',
            fontSize: '12px',
            marginTop: isSmallMobile ? '8px' : '0',
        },
    };

    const totalResults = 250;
    const currentPage = 1;

    return (
        <div style={styles.mainWrapper}>
            <div style={styles.purchaseItemsListPageContainer}>
                <h1 style={styles.headerTitle}>All Purchase Items</h1>

                <div style={styles.purchaseListContainer}>
                    <div style={styles.purchaseListHeader}>
                        <h2 style={styles.purchaseListTitle}>All Purchase Items</h2>
                        <button
                            style={styles.filterDropdown}
                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.filterDropdownHover.backgroundColor}
                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.filterDropdown.backgroundColor}
                        >
                            {selectedMonth} <FaChevronDown />
                        </button>
                    </div>

                    <div style={styles.tableWrapper}>
                        <table style={styles.table}>
                            <thead style={styles.tableHeader}>
                                <tr>
                                    <th style={styles.th}></th> {/* For checkbox */}
                                    <th style={styles.th}>ID</th>
                                    {!isSmallMobile && <th style={styles.th}>Order By</th>}
                                    <th style={styles.th}>Items</th>
                                    <th style={styles.th}>Total</th>
                                    <th style={styles.th}>Purchase Status</th>
                                    {!isSmallMobile && <th style={styles.th}>Payment Method</th>}
                                    {!isSmallMobile && <th style={styles.th}>Date</th>}
                                    <th style={styles.th}>Payment Status</th>
                                    <th style={styles.th}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {purchaseItems.map((item, index) => (
                                    <tr
                                        key={item.id}
                                        style={styles.tableRow}
                                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.tableRowHover.backgroundColor}
                                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                    >
                                        <td style={styles.td}>
                                            <input type="checkbox" style={{ accentColor: '#E5D0A5' }} />
                                        </td>
                                        <td style={styles.td}>#{item.id}</td>
                                        {!isSmallMobile && (
                                            <td style={styles.td}>
                                                <div style={styles.orderByContainer}>
                                                    <div style={styles.profileIcon}>
                                                        {item.orderBy.charAt(0).toUpperCase()}
                                                    </div>
                                                    {item.orderBy}
                                                </div>
                                            </td>
                                        )}
                                        <td style={styles.td}>{item.itemDesc}</td>
                                        <td style={styles.td}>{item.total}</td>
                                        <td style={styles.td}>
                                            <span style={{
                                                ...styles.statusPill,
                                                ...(item.purchaseStatus === 'Item Received' ? styles.statusPillComplete : {})
                                            }}>
                                                {item.purchaseStatus}
                                            </span>
                                        </td>
                                        {!isSmallMobile && <td style={styles.td}>{item.paymentMethod}</td>}
                                        {!isSmallMobile && <td style={styles.td}>{item.date}</td>}
                                        <td style={styles.td}>
                                            <span style={{
                                                ...styles.statusPill,
                                                ...(item.paymentStatus === 'Complete' ? styles.statusPillComplete : styles.statusPillCancel)
                                            }}>
                                                {item.paymentStatus}
                                            </span>
                                        </td>
                                        <td style={styles.td}>
                                            <div style={styles.actionButtons}>
                                                <button
                                                    style={styles.actionButton}
                                                    onClick={() => handleViewItem(item.id)}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.actionButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.actionButton.backgroundColor}
                                                >
                                                    <FaEye style={styles.actionButtonIcon} />
                                                </button>
                                                <button
                                                    style={styles.actionButton}
                                                    onClick={() => handleEditItem(item.id)}
                                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.actionButtonHover.backgroundColor}
                                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.actionButton.backgroundColor}
                                                >
                                                    <FaEdit style={styles.actionButtonIcon} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div style={styles.paginationContainer}>
                        <div style={styles.paginationControls}>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                <FaAngleLeft />
                            </button>
                            {[1, 2, 3, 4, 5, 6].map((page) => (
                                <button
                                    key={page}
                                    style={{
                                        ...styles.paginationButton,
                                        ...(page === currentPage ? styles.paginationButtonActive : {})
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = (page === currentPage ? styles.paginationButtonActive.backgroundColor : styles.paginationButtonHover.backgroundColor)}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = (page === currentPage ? styles.paginationButtonActive.backgroundColor : styles.paginationButton.backgroundColor)}
                                >
                                    {page}
                                </button>
                            ))}
                            <span style={styles.paginationText}> ...... </span>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                25
                            </button>
                            <button
                                style={styles.paginationButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.paginationButtonHover.backgroundColor}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.paginationButton.backgroundColor}
                            >
                                <FaAngleRight />
                            </button>
                        </div>
                        <p style={styles.paginationText}>{totalResults} Results</p>
                    </div>
                </div>
            </div>
        </div>
    );
}